export default "__VITE_ASSET__95554449__"